import classnames from 'classnames';
import T from 'prop-types';
import * as Sentry from '@sentry/browser';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import FileDropTarget from '../../../../shared/components/file-drop-target';
import {
  createMarker,
  updateAudioMarkerWithDuration,
  updateAudioMarkerWithMedia,
  fetchEpisodeMarkers,
} from '../../../../ducks/markers';
import MimeTypes from '../../../../shared/helpers/mime-types';
import navigateTo from '../../../../shared/helpers/navigate-to';
import { createAndUploadEpisode } from '../../../../shared/helpers/upload-episode-audio';

class EpisodeAudioFileDropTarget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDragOver: false,
      isEpisodeBeingCreated: false,
    };
  }

  onDragOver = () => {
    this.setState({ isFileNotAllowed: false, isDragOver: true });
  };

  onDragEnd = () => {
    this.setState({ isDragOver: false });
  };

  onDrop = async file => {
    const {
      onFetchEpisodeMarkers,
      onUpdateAudioMarkerWithDuration,
      onUpdateAudioMarkerWithMedia,
      showId,
    } = this.props;

    this.setState({ isEpisodeBeingCreated: true });

    try {
      const episode = await createAndUploadEpisode({
        showId,
        file,
        onFetchEpisodeMarkers,
        onUpdateAudioMarkerWithDuration,
        onUpdateAudioMarkerWithMedia,
      });
      navigateTo(`/episodes/${episode.id}`);
    } catch (error) {
      this.setState({
        isEpisodeBeingCreated: false,
        isDragOver: false,
      });

      Sentry.captureException(error);
    }
  };

  onFileNotAllowed = () => {
    this.setState({ isFileNotAllowed: true, isDragOver: false });
  };

  renderOverlay() {
    let text;

    if (this.state.isEpisodeBeingCreated) {
      text = 'Episode is being created';
    } else if (this.state.isFileNotAllowed) {
      text = 'File type not supported';
    } else {
      text = 'Drop to create episode';
    }

    return (
      <div
        className={classnames('episode-audio-file-drop-target-overlay', {
          'episode-audio-file-drop-target-overlay--is-drag-over': this.state.isDragOver,
        })}
      >
        <p className="episode-audio-file-drop-target-overlay__text">{text}</p>
      </div>
    );
  }

  render() {
    return (
      <FileDropTarget
        className="episode-audio-file-drop-target"
        types={['Files']}
        allow={MimeTypes.Audio}
        onDragOver={this.onDragOver}
        onDragEnd={this.onDragEnd}
        onDrop={this.onDrop}
        onFileNotAllowed={this.onFileNotAllowed}
      >
        {this.props.children}
        {this.renderOverlay()}
      </FileDropTarget>
    );
  }
}

EpisodeAudioFileDropTarget.propTypes = {
  children: T.node.isRequired,
  onCreateMarker: T.func.isRequired,
  onFetchEpisodeMarkers: T.func.isRequired,
  onUpdateAudioMarkerWithDuration: T.func.isRequired,
  onUpdateAudioMarkerWithMedia: T.func.isRequired,
  showId: T.string.isRequired,
};

export default connect(
  () => ({}),
  {
    onCreateMarker: createMarker,
    onFetchEpisodeMarkers: fetchEpisodeMarkers,
    onUpdateAudioMarkerWithDuration: updateAudioMarkerWithDuration,
    onUpdateAudioMarkerWithMedia: updateAudioMarkerWithMedia,
  }
)(EpisodeAudioFileDropTarget);
